<template>
  <div class='list-content'>
    <Header :leftIcon='leftIcon' :rightIcon='rightIcon' />
    <div class='bottom-list'>
      <deviceList ref='deviceList' />
    </div>
    <analItem ref='analDia' :title='title' :isShow.sync='isShow' :defaultSetting='setting' :config='analSetting'
              @save='analSetSave' @saveImpl='analSetSaveImpl' />
  </div>
</template>

<script>
import analItem from '../../../../../dialog/analItem.vue'
import Header from '../Header.vue'
import deviceList from './deviceList.vue'
import analSetting from '../../config/analSetting'
import { analSettingSave, getAnalSetting } from '@/api/modules/monitorPoint'
// 默认的analItem的配置
import bus from '@/utils/bus'
import { analItemConvert } from '@/utils/convert'
import setting from '../default/setting'

export default {
  components: {
    Header,
    deviceList,
    analItem
  },
  data () {
    return {
      setting,
      // 数据分析设置配置项
      analSetting: analSetting,
      leftIcon: [],
      rightIcon: [
        {
          id: 1,
          title: $t('integration.data_analysis_settings'),
          icon: 'el-icon-setting',
          click () {
            this.title = $t('integration.data_analysis_settings')
            this.isShow = true
          }
        },
        {
          id: 2,
          title: $t('integration.data_board'),
          icon: 'iconfont icon-shujukanban',
          click () {
            bus.$emit('reflashData', this.$refs.deviceList.carrierList.map(item => item.id).join(','))
          }
        }
      ],
      // 设置数据
      isShow: false,
      title: '',
      config: null
    }
  },
  watch: {
    config () {
      this.initAnalIcon()
    }
  },
  methods: {
    handleClick (item) {
      if (item.id === 1) {
        this.isShow = true
        this.title = $t('integration.data_analysis_settings')
      }
    },
    // 数据分析设置保存
    analSetSave (param) {
      this.config = param
      analSettingSave(param).then(async res => {
        if (res.result) {
          await this.$resultHandle(res.state)
        }
      })
    },
    // 数据分析设置保存并执行
    analSetSaveImpl (param) {
      this.analSetSave(param)
      bus.$emit('analSetConfig', param)
    },
    // 获取监测点设置
    getAnalSetting () {
      getAnalSetting().then(({ result }) => {
        // 默认配置  未进行配置的情况则加载默认配置
        if (!result) {
          result = setting
        }
        this.$refs.analDia.setConfig(result)
        this.config = result
        this.initAnalIcon()
        bus.$emit('analSetConfig', result)
      })
    },
    initAnalIcon () {
      let id = 0
      this.leftIcon = []
      // 从 analItem 组件获取 check 状态
      const dataAnalysis = this.$refs.analDia ? this.$refs.analDia.dataAnalysis : null
      if (!dataAnalysis) return
      Object.keys(dataAnalysis).forEach(key => {
        if (dataAnalysis[key].check) {
          this.leftIcon.push({
            id: ++id,
            title: this.$t(analItemConvert(key).title),
            icon: analItemConvert(key).icon
          })
        }
      })
    }
  },
  mounted () {
    this.getAnalSetting()
  },
  beforeDestroy () {
  }
}
</script>

<style lang='scss' scoped>
.list-content {
  width: 100%;
  height: calc(100% - 2px);
  border: 1px solid #cccccc;
  margin-left: -1px;

  .bottom-list {
    height: calc(100% - 40px);
    width: 100%;
  }
}
</style>
